<a [routerLink]='news.url' [attr.aria-label]="news.title" class="news-item">
  <div *ngIf='news.previewImage' class="news-item__image">
      <picture ubl-picture [data]='news.previewImage' [ratio]="16/9" fallback="https://picsum.photos/200/300c" lazy></picture> 
  </div>
  <div class="news-item__info">
    <h3 class="news-item__title"> {{news.title}}</h3>
    <div class="news-item__descr" [innerHTML]='news.description'></div>
    <span class="news-item__date">{{news.publishDateString}}</span>
  </div>
</a>
